<template>
  <div class="link-folder">
    <base-list
      ref="fileList"
      :header-info="headerInfo"
      :sort-info="sortInfo"
      :file-list="fileList"
      :is-list-mode="isListMode"
      :switch-mark="switchMark"
      :is-loading="isLoading"
      :is-disabled="checkboxIsDisable"
      :show-big-more="showBigMore"
      @loadMore="loadMore"
      @doSort="doSort"
      @itemClick="itemClick"
      @setPosition="setPosition"
      @itemHover="itemHover"
    >
      <!-- 修改布局icon -->
      <span
        slot="operView"
        class="operView"
      >
        <!-- 气泡提示 -->
        <co-tips
          class="item"
          effect="dark"
          :content="isListMode ? $t('图标显示') : $t('列表显示')"
          placement="top"
        >
          <a
            class="checkModeType"
            href="javascript:;"
            @click="changeListMode"
          >
            <img
              class="other-icon"
              :src="isListMode
                ? require('../../../../../static/image/list-view.svg')
                : require('../../../../../static/image/card-view.svg')"
              alt=""
            >
          </a>
        </co-tips>

      </span>

      <!--列表操作项目-->
      <template
        slot="operation"
        slot-scope="{data: {index, currentData, operationState, otherData}}"
      >
        <file-item-operation
          v-if="operationState"
          ref="operation"
          :current-data="currentData"
          :index="index"
          :is-list-mode="isListMode"
          :operation="powerButton"
          :select-file="$refs.fileList.selectFile"
          @setPosition="setPosition"
          @singleSelectOperation="singleSelect"
          @operationAction="operationAction"
        />
      </template>

      <!--图标操作项-->
      <template
        slot="icongroup"
        slot-scope="{data: {index, currentData, otherData}}"
      >
        <co-tips
          class="item"
          effect="dark"
          :content="$t('锁定')"
          placement="top"
        >
          <span
            class="lock-icon"
            :class="{'locked': !!currentData.lock_uid}"
          />
        </co-tips>
      </template>

      <!--文件内容为空-->
      <template slot="nothing">
        <div class="no-file">
          <svg class="empty-pic">
            <use xlink:href="#filelist-empty" />
          </svg>
          <p class="empty-title">
            {{ $t('文件夹为空') }}
          </p>
        </div>
      </template>
    </base-list>

    <!-- 右键菜单 -->
    <context-menu
      :menu-position="menuPosition"
      :context-data="menuRightButton"
      @operationAction="operationAction"
    />
  </div>
</template>

<script>
import coTips from 'components/common/tips/index.vue'
import baseList from 'components/common/folderList/base.vue' // 引入外联文件夹列表组件
import fileItemOperation from 'components/common/folderList/file-item-operation.vue' // 操作按钮组件
import contextMenu from 'components/common/folderList/context-menu.vue' // 右键菜单组件
import _$ from 'js/api/getdata.js'
import * as Util from 'js/util/util.js'

export default {
  components: {
    baseList,
    fileItemOperation,
    contextMenu,
    coTips,
  },
  props: {
    /**
         * 文件列表信息
         */
    fileList: {
      type: Object,
      default() {
        return {
          content: [],
        }
      },
    },
    /** 加载的loading */
    isLoading: {
      type: Boolean,
      default: false,
    },
    isFerry: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // 头部列表数据
      headerInfo: {
        list: [{
          title: this.isFerry ? '项目名称' : '文件名', // 名字
          name: 'name', // key
          class: 'name-title', // className
          drag: false, // 是否能拖拽
          sort: true, // 是否显示排序图标
          sortStatus: 0, // 排序图标状态  0: 无状态; 1: 升序 2: 降序
          sortName: this.isFerry ? '项目名称' : '文件名', // 用于排序入口中的名称展示
        }, {
          title: '时间',
          name: 'mtime',
          class: 'mtime-update-title',
          drag: true,
          sort: true,
          sortStatus: 2,
          sortName: '更新时间',
        }, {
          title: '大小',
          name: 'size',
          class: 'size-title',
          drag: true,
          sort: true,
          sortStatus: 0,
          sortName: '大小',
        }],
        checkbox: false, // 头部是否显示checkbox
        replaceAllHeaderInfo: false, // 全选的时候,是否隐藏头部数据
        haveBigSort: true,
      },
      sortInfo: [
        {
          name: 'name', // key
          sort: true, // 是否显示排序图标
          sortStatus: 0, // 排序图标状态  0: 无状态; 1: 升序 2: 降序
          sortName: '文件名', // 用于排序入口中的名称展示
        }, {
          name: 'mtime',
          sort: true,
          sortStatus: 2,
          sortName: '更新时间',
        }, {
          name: 'size',
          sort: true,
          sortStatus: 0,
          sortName: '大小',
        },
      ],
      // 判断是否为列表模式
      isListMode: true,
      // (一个解决低版本safari浏览器由列表切换试图模式时，列表错乱的BUG属性),设置为表头切换属性
      switchMark: true,
      // 设置右键弹出的位置
      menuPosition: {
        left: 0,
        top: 0,
        isShow: false,
      },
      // 外链权限按钮,列表按钮
      powerButton: [],
      // 鼠标menu右键展示按钮
      menuRightButton: [],
      // 默认要展示的图标
      defaultOperation: {
        preview: {
          ref: 'preview',
          class: 'icon icon-i-preview',
          name: '预览',
          operateType: 0,
          svgId: '#preview',
          showLine: false,
          x: '4.5',
          y: '3.5',
        },
        download: {
          ref: 'download',
          class: 'icon icon-i-download',
          name: '下载',
          operateType: 0,
          svgId: '#download',
          showLine: false,
        },
        savetobox: {
          ref: 'savetobox',
          class: 'icon icon-i-savetobox',
          name: '转存至网盘',
          operateType: 0,
          svgId: '#save',
          showLine: false,
        },
        modeMore: {
          ref: 'mode-more',
          class: 'icon icon-i-operation-more',
          name: '更多操作',
          operateType: 0,
          svgId: '#more',
          showLine: false,
        },
      },
      // checkbox是否可以点击,默认可以点击
      checkboxIsDisable: false,
      // 显示更多按钮
      showBigMore: true,
      character: '',
    }
  },
  computed: {
    isFerryApprove() {
      return this.$route.name === 'approveFile' && this.isFerry
    },
  },
  watch: {
    /**
         * 监听fileList判断checkbox是否可以点击
         */
    fileList: {
      handler(n) {
        if (n.content.length > 0 && !this.isFerryApprove && this.$route.name !== 'ferry') {
          if (sessionStorage.getItem('character') !== 'approver') {
            this.showBigMore = false
            return false
          }
          this.showBigMore = ((/^preview/.test(n.content[0].access_mode)) || (/download/.test(n.content[0].access_mode)))
        }
      },
      deep: true,
    },
  },
  created() {
    // 重新判断list模式
    if (localStorage.getItem('Mode') != '' && localStorage.getItem('Mode') != undefined) {
      this.isListMode = localStorage.getItem('Mode') === 'list'
    }
    if (this.isFerryApprove) {
      this.character = sessionStorage.getItem('character')
      if (this.character === 'approver') {
        this.showBigMore = true
      } else if (this.character === 'applier') {
        this.showBigMore = false
      }
    }
    if (this.$route.name === 'ferry') {
      if (sessionStorage.getItem('auth') === 'list') {
        this.showBigMore = false
      } else {
        this.showBigMore = true
      }
    }
  },
  methods: {
    /**
         * 获取选中的文件
         */
    getSelectFile() {
      return this.$refs.fileList.selectFile
    },
    /**
         * 清楚选中数据
         */
    clearSelect() {
      // 进入文件夹清空vuex里存的选中
      this.$refs.fileList.selectFile.selectedDataClear()
    },
    /**
         * 添加选中的数据
         */
    setSelectFile(data) {
      if (this.fileList.content && this.fileList.content.length > 0) {
        const result = []
        this.fileList.content = this.fileList.content.map((v, i) => {
          if (data.indexOf(v.neid) >= 0) {
            v.checked = true
            result.push({
              index: i,
              data: v,
            })
          }
          return v
        })
        this.$refs.fileList.selectFile.data = result
      }
    },
    /**
         * 列表的hover抛出
         */
    itemHover(data) {
      if (this.isFerryApprove) {
        this.getFerryApprovePreviewButton(data)
      } else if (this.$route.name === 'ferry') {
        this.getFerryPreviewButton(data)
      } else {
        this.getPreviewButton(data.access_mode, data.isDir, data)
      }
    },
    // 判断文件的大小限制
    async checkFileLimit(data) {
      return true
    },
    /**
         * 获取要展示的按钮
         */

    getPreviewButton(access_mode, isDir, data) {
      // 获取权限表
      if (sessionStorage.getItem('character') === 'applier') {
        return false
      }
      const operationPower = access_mode
      // 清空原有数据
      this.powerButton = []
      // 创建新的存储
      const powerButton = []
      // 预览权限,支持类型,文件大小
      if ((/^preview/.test(operationPower) || data.support_preview === "true") && !isDir && Util.suppportPreview(data) && this.checkFileLimit(data)) {
        powerButton.push(this.defaultOperation.preview)
      }
      // 下载,转存依赖于下载权限
      if (/download/.test(operationPower)) {
        // 非apk文件
        if (!/\.apk$/.test(data.mime_type)) {
          this.defaultOperation.download.name = '下载'
          powerButton.push(this.defaultOperation.download)
        }
      }
      if (this.isListMode) {
        this.powerButton = powerButton
      } else {
        // 大图模式显示更多
        if (this.showBigMore) {
          if (powerButton.length > 0) {
            this.defaultOperation.modeMore.name = '更多操作'
          } else {
            this.defaultOperation.modeMore.name = '没有操作权限'
          }
          this.powerButton.push(this.defaultOperation.modeMore)
        }
      }
    },
    /**
     * 摆渡审批详情展示的按钮
     */
    getFerryApprovePreviewButton(data) {
      // 清空原有数据
      this.powerButton = []
      // 创建新的存储
      const powerButton = []
      if (sessionStorage.getItem('character') === 'approver') {
        // 支持类型,文件大小
        if (!data.isDir && data.support_preview === "true" && this.checkFileLimit(data)) {
          powerButton.push(this.defaultOperation.preview)
        }
        // 非apk文件
        if (!/\.apk$/.test(data.mime_type)) {
          this.defaultOperation.download.name = '下载'
          powerButton.push(this.defaultOperation.download)
        }
      }
      if (this.isListMode) {
        this.powerButton = powerButton
      } else {
        if (this.character === 'approver') {
          if (powerButton.length > 0) {
            this.defaultOperation.modeMore.name = '更多操作'
          } else {
            this.defaultOperation.modeMore.name = '没有操作权限'
          }
          this.powerButton.push(this.defaultOperation.modeMore)
          this.showBigMore = true
        } else if (this.character === 'applier') {
          this.showBigMore = false
        }
      }
    },
    /**
         * 获取鼠标右键的按钮展示
         */
    getFerryPreviewButton(data) {
      // 清空原有数据
      this.powerButton = []
      // 创建新的存储
      const powerButton = []
      // 预览权限,支持类型,文件大小
      if (!data.isDir && data.support_preview === "true" && this.checkFileLimit(data) && sessionStorage.getItem('auth') === 'preview') {
        powerButton.push(this.defaultOperation.preview)
      }
      if (this.isListMode) {
        this.powerButton = powerButton
      } else if (this.showBigMore) {
        if (powerButton.length > 0) {
          this.defaultOperation.modeMore.name = '更多操作'
        } else {
          this.defaultOperation.modeMore.name = '没有操作权限'
        }
        this.powerButton.push(this.defaultOperation.modeMore)
      }
    },

    getFerryMouseRightButton() {
      this.menuRightButton = []
      const selectType = this.$refs.fileList.selectFile.type()
      const oneData = this.$refs.fileList.selectFile.data['0'].data
      if (sessionStorage.getItem('auth') === 'preview') {
        // 预览下载
        if (selectType !== 'multi') {
          if (oneData.isDir) {
            this.menuRightButton.push({
              ref: 'openDir',
              name: '打开',
              operateType: 0,
              showLine: false,
            })
          }
          if (selectType === 'file' && Util.suppportNormalPreview(oneData) && this.checkFileLimit(oneData)) { this.menuRightButton.push(this.defaultOperation.preview) } // 预览
        }
      } else if (oneData.isDir) {
        this.menuRightButton.push({
          ref: 'openDir',
          name: '打开',
          operateType: 0,
          showLine: false,
        })
      }
    },
    getMouseRightButton() {
      if (sessionStorage.getItem('character') === 'applier') {
        return false
      }
      // 清空原有按钮
      this.menuRightButton = []
      // 获取权限表
      const operationPower = this.fileList.content['0'].access_mode
      // 选中的为单个文件
      const selectType = this.$refs.fileList.selectFile.type()
      if (selectType != 'multi') {
        const oneData = this.$refs.fileList.selectFile.data['0'].data
        // 预览
        if (oneData.isDir) {
          this.menuRightButton.push({
            ref: 'openDir',
            name: '打开',
            operateType: 0,
            showLine: false,
          })
        }
        if (/^preview/.test(operationPower) && selectType == 'file' && Util.suppportPreview(oneData) && this.checkFileLimit(oneData)) { this.menuRightButton.push(this.defaultOperation.preview) }
        // 下载,转存依赖于下载权限
        if (/download/.test(operationPower)) {
          // 非apk文件
          if (!/\.apk$/.test(oneData.mime_type)) {
            this.defaultOperation.download.name = '下载'
            this.menuRightButton.push(this.defaultOperation.download)
          }
        }
      }
    },
    /**
     * 获取摆渡审批右键按钮
     */
    getExchangeApproveMouseRightButton() {
      // 清空原有数据
      this.menuRightButton = []
      // 选中的为单个文件
      const selectType = this.$refs.fileList.selectFile.type()
      if (selectType !== 'multi') {
        const oneData = this.$refs.fileList.selectFile.data['0'].data
        if (sessionStorage.getItem('character') === 'approver') {
          if (oneData.isDir) {
            this.menuRightButton.push({
              ref: 'openDir',
              name: '打开',
              operateType: 0,
              showLine: false,
            })
          }
          // 支持类型,文件大小
          if (selectType === 'file' && Util.suppportNormalPreview(oneData) && this.checkFileLimit(oneData)) { this.menuRightButton.push(this.defaultOperation.preview) }
          // 非apk文件
          if (!/\.apk$/.test(oneData.mime_type)) {
            this.defaultOperation.download.name = '下载'
            this.menuRightButton.push(this.defaultOperation.download)
          }
        }
      }
    },
    /**
         * 滚动加载更多数据
         */
    loadMore() {
      this.$emit('scrollLoadMore')
    },
    /**
         * 排序事件
         */
    doSort(data) {
      // 进入文件夹清空vuex里存的选中
      this.$refs.fileList.selectFile.selectedDataClear()
      this.$emit('doSort', data)
    },
    /**
         * 鼠标点击事件
         */
    itemClick(data) {
      if (data.isDir) {
        // 进入文件夹清空vuex里存的选中
        this.$refs.fileList.selectFile.selectedDataClear()
      }
      this.$emit('itemClick', data)
    },
    /**
         * 改变列表的展示模式
         */
    changeListMode() {
      if (this.isListMode) { // 解决低版本safari浏览器由列表切换试图模式时，列表错乱的BUG
        this.switchMark = false
        this.isListMode = !this.isListMode
        this.$nextTick(() => {
          this.switchMark = true
        })
      } else {
        this.isListMode = !this.isListMode
      }
      this.isListMode ? localStorage.setItem('Mode', 'list') : localStorage.setItem('Mode', 'icon')
    },
    // 为右键菜单定位
    setPosition(obj) {
      // 重新计算需要显示的按钮
      this.menuPosition = obj
      // 设置文件权限按钮
      if (this.isFerryApprove) {
        this.getExchangeApproveMouseRightButton()
      } else if (this.$route.name === 'ferry') {
        this.getFerryMouseRightButton()
      } else {
        this.getMouseRightButton()
      }
      // 设置遮罩,在有按钮的情况下，才会显示
      if (this.menuRightButton.length > 0) {
        this.$cusMask.show(() => {
          this.menuPosition.isShow = false
          this.$cusMask.hide()
        })
      }
    },
    /**
         * operation操作项的点击选中事件
         */
    singleSelect({ index, data }) {
      // 采用fileItem内部选中逻辑
      this.$refs.fileList.singleSelect({ index, currentData: data })
    },
    /**
         * 点击操作按钮触发的方法
         */
    operationAction({ name, operateType }) {
      // 关闭遮罩
      this.$cusMask.hide()
      const selectData = this.$refs.fileList.selectFile
      this.$emit('operationAction', { name, operateType, selectData })
    },
  },
}
</script>

<style lang="less">
.link-folder{
  height: 100%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding:0px 24px 0px 60px;
  background-color:#fff;
}

//没有文件图标剧中显示
.no-file{
  text-align:center;
}
.no-file .empty-pic {
  margin-top: 130px;
  width: 130px;
  height: 130px;
  display: inline-block;
}
.ferry-info + .link-box-body .no-file .empty-pic {
  margin-top: 50px;
}
.no-file .empty-title {
  font-size: 14px;
  color: #1b2733;
  margin-top: 16px;
  text-align: center;
}

/**锁定文件图标 */
.lock-icon {
  vertical-align: bottom;
  position: relative;
  display: none;
  width: 20px;
  height: 20px;
  background: url(~image/file-operate.png) -45px -85px;
  &.locked {
    display: inline-block;
  }
  top: 0px;
  margin-left:0px;
}

/**
     * 设置模式切换的样式,兼容ie
     */
.checkModeType{
  position: relative;
  cursor: pointer;
  display: inline-block;
  width: 26px;
  height: 26px;
  border-radius: 2px;
}
.checkModeType:hover{
  background-color: #e8ebef;
}
.other-icon {
  pointer-events: none;
  width: 14px;
  height: 14px;
  padding: 6px;
  border-radius: 2px;
  &:hover {
    background-color: #e8ebef;
  }
}
</style>
